<template>
    <v-container fluid class="pb-12">

        <v-row justify-center wrap>

            <v-col class="hidden-md-and-down" lg="4" >
              <attention-summary
                  height="82vh"
                  sticky
                  :event="summaryEvent"
                  v-if="isAttentionScreen && !loadingEvent && currentEventIsActive"/>
            </v-col>

            <v-col cols="12" :lg="currentEventIsActive ? 8 : 12" text-center>

                <client-placeholder v-if="loadingEvent"/>

                <template v-else>

                    <v-slide-y-transition>
                        <event-card
                                style="border-radius: 10px"
                                v-show="!loadingEvent"
                                :event="currentEvent"
                                @appointment:cancel="$emit('appointment:cancel', $event)"
                                @edit:client="$emit('edit:client', $event)"
                                @attention:start="$emit('attention:start', $event)"
                                @attention:end="$emit('attention:end')"
                        />
                    </v-slide-y-transition>

                    <v-slide-y-transition v-if="currentEvent !== null && currentEvent.event_status && currentEvent.event_status.id !== 4">
                        <div v-show="currentEvent.event_status.id !== 4">
                            <slot name="summary" :event-details="currentEvent" />
                        </div>
                    </v-slide-y-transition>

                    <v-slide-y-transition v-else>
                        <div v-show="currentEvent !== null && !loadingEvent">
                            <slot name="body" :event-details="currentEvent" />
                        </div>
                    </v-slide-y-transition>

                </template>

            </v-col>
        </v-row>
      <v-dialog v-model="setTemplateDialog" max-width="600" persistent>
        <v-card>
          <v-card-title class="pb-0">
            <h1 class="title">Elige un estilo</h1>
          </v-card-title>
          <v-card-title class="py-0">
            <p>¿Cómo quieres que luzca tu ficha?</p>
          </v-card-title>
          <v-card-text class="py-1 text-center">
            <attention-template-picker ref="templatePicker" @saved="onTemplateSet" />
            <small>*Podrás cambiar esto después desde <b>configuraciones > más > ficha</b></small>
          </v-card-text>
          <v-card-actions>

            <v-spacer></v-spacer>
            <v-btn :loading="savingTemplate" color="primary" @click="setTemplate">
              <v-icon left>fa-check</v-icon>
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
</template>

<script>

    import {mapState, mapMutations} from 'vuex'
    import {getLabel} from '@/utils/Institution'

    import AttentionSummaryDrawer from "../toolset/AttentionSummaryDrawer.vue";
    import WMainTitle from '@/components/common/WMainTitle'
    import EventCard from '@/components/appointments/attention/EventCard'
    import ClientPlaceholder from '@/components/appointments/attention/ClientPlaceholder'
    import AttentionTemplatePicker from "@/components/providers/settings/AttentionTemplatePicker";
    import {isAttentionComponentTypeChoiceAvailable} from "@/utils/Specialist";
    import AttentionSummary from "../AttentionSummary.vue";


    export default{
        components: {
          AttentionSummary,
          AttentionTemplatePicker,
          WMainTitle,
          EventCard,
          ClientPlaceholder,
        },
        data(){
          return {
              setTemplateDialog: false,
              savingTemplate: false,
              breadcrumbs: [
                  {
                      text: 'Inicio',
                      disabled: false,
                      href: '/panel/dashboard'
                  },
                  {
                      text: 'Atención',
                      disabled: true,
                      href: ''
                  },
              ],
          }
        },
        computed:{
            ...mapState('clientAttention', {
                summaryEvent: state => state.summaryEvent,
                currentEvent: state => state.currentEvent,
                loadingEvent: state => state.loading,
                attentionSummaryDrawer: state => state.attentionSummaryDrawer
            }),
            isAttentionScreen(){
              return this.$route.name === 'panel.provider.specialist_daily_schedule'
            },
            currentEventIsActive(){
              const vm = this
              return vm.currentEvent
                  && vm.currentEvent.event_status_id === 4
            }
        },
        mounted(){
            const vm = this
            const isSet = localStorage.attention_template_set


            if(!isSet && isAttentionComponentTypeChoiceAvailable()){
              vm.setTemplateDialog = true
            }

        },
        methods:{
          ...mapMutations(['showClientList']),
          ...mapMutations('clientAttention', [ 'setEvent' ]),
          getLabel,
          onEventsChange(events) {
            this.$emit('change:events', events)
          },
          setTemplate(){
              const vm = this
              vm.savingTemplate = true
              vm.$refs.templatePicker.save()
          },
          onTemplateSet(){
              const vm = this
              vm.setTemplateDialog = false
              vm.savingTemplate = false
              localStorage.attention_template_set = 1
          }
        }
    }
</script>

<style scoped>
  .top-btns{
    position: fixed;
    text-align: left;
    border-radius: 30px 0 0 30px;
    top: 55px;
    right: 0;
    width: 110px;
    padding: 10px;
    z-index: 5;
    background: var(--v-secondary-card-base);
    background: linear-gradient(90deg, var(--v-secondary-card-base) 0%, rgba(255,255,255,0) 100%);
  }
</style>
